export default __webpack_public_path__ + "static/media/the-recipe-room.e7ba714d.mp4";